module.exports = __webpack_public_path__ + "img/187.afabbcc0.jpg";